var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.areThereSomeImage)?_c('div',{staticClass:"BlockGallery-CarouselContainer",domProps:{"innerHTML":_vm._s(_vm.templateGallery)}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }